import { Monitor, Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";

type Theme = "light" | "dark" | "system";

const cycle: Theme[] = ["light", "dark", "system"];

function applyTheme(theme: Theme) {
	const isDark =
		theme === "dark" ||
		(theme === "system" && matchMedia("(prefers-color-scheme:dark)").matches);
	document.documentElement.classList.toggle("dark", isDark);
}

export default function ThemeToggle() {
	const [theme, setTheme] = useState<Theme>("system");

	useEffect(() => {
		const stored = localStorage.getItem("theme") as Theme | null;
		if (stored && cycle.includes(stored)) {
			setTheme(stored);
		}
	}, []);

	useEffect(() => {
		applyTheme(theme);
		localStorage.setItem("theme", theme);

		if (theme === "system") {
			const mq = matchMedia("(prefers-color-scheme:dark)");
			const handler = () => applyTheme("system");
			mq.addEventListener("change", handler);
			return () => mq.removeEventListener("change", handler);
		}
	}, [theme]);

	function next() {
		setTheme((t) => cycle[(cycle.indexOf(t) + 1) % cycle.length]);
	}

	const Icon = theme === "light" ? Sun : theme === "dark" ? Moon : Monitor;
	const label =
		theme === "light" ? "Light" : theme === "dark" ? "Dark" : "System";

	return (
		<button
			onClick={next}
			className="p-2 hover:bg-secondary rounded-lg transition-colors"
			aria-label={`Theme: ${label}`}
			title={`Theme: ${label}`}
		>
			<Icon size={18} />
		</button>
	);
}
